import trackSDK from '@sf-me/track-sdk'

trackSDK.init({
  system_code: 'MCS-CAS-EXP',
  product_code: 'shein_order_web',
  show_log: false,
  // sit对应使用客渠灰度环境的神策地址，prod对应使用生产环境的神策地址，默认为sit
  platform_env: 'prod',
})

const { $sensors: sensors } = trackSDK
export default sensors
